import "./Checkout.css";
import {
  Card,
  Col,
  Divider,
  Row,
  Input,
  Typography,
  Flex,
  Modal,
  Button,
  InputNumber,
  Radio,
  Space,
} from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  QuestionCircleFilled,
} from "@ant-design/icons";
import { IoIosInformationCircle } from "react-icons/io";
//import experienceData from "../../experienceData.json";
import { useState, useEffect, useMemo } from "react";
import "react-calendar/dist/Calendar.css";
import { getUsersTourDataFromUrl } from "../../common/helper";
import Api from "../../AppUtils";
import AvailabilityDatesCalender from "../../components/AvailabilityDatesCalender";
import Navbar from "../../components/Navbar";
import DownloadWegetherModal from "../../components/DownloadWegetherModal";
import { useNavigate, useParams } from "react-router-dom";
import StyledCard from "../../components/StyledCard";
import { RiUserLocationLine, RiReceiptFill } from "react-icons/ri";
import { FaRegCreditCard } from "react-icons/fa6";
import { validPartyTypeForExperience } from "../../common/helper";
import ParticipantsControlModal from "../../components/ParticipantsControlModal";
import PartyIcon from "../../components/PartyIcon";
import { FaRegCalendar } from "react-icons/fa6";
import { FaGlobe, FaRegClock, FaRegTimesCircle } from "react-icons/fa";
import BookingDetailsMenuItem from "../../components/checkout/BookingDetailsMenuItem";
import { addUsersTourDataToUrl } from "../../common/helper";
import { calculatePriceForParty } from "../../common/helper";
import PaymentSection from "../../components/PaymentSection";
import {
  useStripe,
  useElements,
  CardElement,
  Elements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripeTrust from "../../components/StripeTrust";
import AccountStatusCard from "../../components/AccountStatusCard";
import CustomCheckbox from "../../components/CustomCheckbox";
import TextArea from "antd/es/input/TextArea";
import Popover from "../../components/Popover";
import env from "../../env.json";

const PUBLISHABLE_LIVE_KEY = env.PUBLISHABLE_LIVE_KEY;

const stripePromise = loadStripe(PUBLISHABLE_LIVE_KEY);
const { Title, Text } = Typography;

function Checkout() {
  const navigate = useNavigate();
  const [downloadAppModalVisible, setDownloadAppModalVisible] = useState(false);

  const initialUsersTourData = useMemo(() => {
    try {
      return getUsersTourDataFromUrl(window.location.href);
    } catch (error) {
      window.location.href = "/not-found";
    }
  }, []);

  const { expId } = useParams();

  const [tourDetails, setTourDetails] = useState({
    id: initialUsersTourData?.experienceId,
    experienceName: initialUsersTourData?.experienceName,
  });
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [partyType, setPartyType] = useState(initialUsersTourData?.partyType);
  const [selectedDateTime, setSelectedDateTime] = useState(
    initialUsersTourData?.selectedTime
  );
  const [guests, setGuests] = useState(initialUsersTourData?.guests || {});

  const [bookingSectionIconStatus, setBookingSectionIconStatus] =
    useState(false);
  const [paymentSectionIconStatus, setPaymentSectionIconStatus] =
    useState(false);
  const [isAgreementAccepted, setIsAgreementAccepted] = useState(false);
  const [titleLevel, setTitleLevel] = useState({});
  const [isCalendarVisible, setIsCalendarVisible] = useState(false);
  const [isParticipantModalVisible, setIsParticipantModalVisible] =
    useState(false);

  const [isUserPartyTypeModalVisible, setIsUserPartyTypeModalVisible] =
    useState(false);

  const [guestModalVisible, setGuestModalVisible] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1225);

  const [accountExistenceStatusMessage, setAccountExistenceStatusMessage] =
    useState("");

  const [loadingCheckout, setLoadingCheckout] = useState(false);
  const [showContactSupportSection, setShowContactSupportSection] =
    useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1225);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 500) {
        setTitleLevel({ main: 2, sub: 4 });
      } else {
        setTitleLevel({ main: 4, sub: 5 });
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    (async () => {
      let resp = await Api.getTourDetails(expId);
      setTourDetails({
        ...resp,
      });
    })();
  }, []);

  const showCalendar = () => {
    setIsCalendarVisible(true);
  };

  const handleParticipantChange = (type, value) => {
    const totalParticipants =
      value +
      guests.children +
      guests.elderly +
      (type === "adults" ? 0 : guests.adults);
    if (totalParticipants <= tourDetails?.maxParticipants) {
      setGuests((prev) => ({
        ...prev,
        [type]: value,
      }));
    }
  };

  const totalParticipants = guests.adults + guests.children + guests.elderly;

  useEffect(() => {
    setBookingSectionIconStatus(
      email !== "" && email === confirmEmail && totalParticipants > 0
    );
  }, [email, confirmEmail, totalParticipants]);

  function formatCurrency(value) {
    // Ensure the input is a number
    if (typeof value !== "number") {
      throw new Error("Input must be a number");
    }

    // Format the number to two decimal points and add dollar sign
    return `$${value.toFixed(2)}`;
  }

  const handleDateTimeSelect = (dateTime) => {
    console.log("this is selceted datetime");

    setSelectedDateTime(dateTime);
  };

  const revisitedHandleCheckoutButtonPress = async (e, stripe, elements) => {
    e.preventDefault();

    setLoadingCheckout(true);

    if (!stripe || !elements) {
      return;
    }

    const card = elements.getElement(CardElement);
    const result = await stripe.createToken(card);

    if (result.error) {
      console.log(result.error.message);
      alert("Payment processing error: " + result.error.message);
      setLoadingCheckout(false);
      return;
    }

    try {
      const response = await Api.checkout({
        userData: {
          email: email,
          firstName: firstName,
        },
        userTourData: {
          participants: guests?.adults + guests?.children + guests?.elderly,
          party: guests,
          selectedDateTime: selectedDateTime,
          partyType: partyType,
        },
        tourDetails: {
          location: tourDetails?.location,
          experience_id: tourDetails?.id,
        },
        token: result.token?.id,
      });

      if (response.message === "Success") {
        // console.log(response, "Response Structure");

        const attributes = response.tourDetail.Attributes; // Access Attributes

        console.log(attributes.total, "i amhere");
        console.log(attributes.party.size, "i amhere");
        console.log(
          attributes?.tripDetails?.[
            Object.keys(attributes.tripDetails || {})[0]
          ].tours[0].experienceName,
          "i amhere"
        );
        console.log(
          attributes?.tripDetails?.[
            Object.keys(attributes.tripDetails || {})[0]
          ].tours[0].experienceType,
          "i amhere"
        );
        console.log(
          attributes?.tripDetails?.[
            Object.keys(attributes.tripDetails || {})[0]
          ].tours[0].meetUpTime,
          "i amhere"
        );
        console.log(
          "Card Data (Stringified):",
          JSON.stringify(response.cardData, null, 2)
        );

        let data = {
          last4: response.cardData?.last4,
          paymentType: response.cardData?.paymentType,
          email: response.cardData?.email,
          firstName: firstName,
          experienceName: tourDetails?.experienceName,
          experienceType: tourDetails?.experienceType,
          date: selectedDateTime?.date,
          meetUpTime: selectedDateTime?.startTime,
          id: response.cardData?.id,
          brand: response.cardData?.brand,
          object: response.cardData?.object,
          size: attributes.party.size,
          subTotal: formatCurrency(
            calculatePriceForParty(
              tourDetails?.experienceType || "Shared",
              tourDetails?.baseSharedPrice,
              tourDetails?.basePrivatePrice,
              tourDetails?.extraPersonPrice,
              partyType,
              guests.adults + guests.children + guests.elderly
            )
          ),
          tax: formatCurrency(
            calculatePriceForParty(
              tourDetails?.experienceType || "Shared",
              tourDetails?.baseSharedPrice,
              tourDetails?.basePrivatePrice,
              tourDetails?.extraPersonPrice,
              partyType,
              guests.adults + guests.children + guests.elderly
            ) / 10
          ),
          total: formatCurrency(
            calculatePriceForParty(
              tourDetails?.experienceType || "Shared",
              tourDetails?.baseSharedPrice,
              tourDetails?.basePrivatePrice,
              tourDetails?.extraPersonPrice,
              partyType,
              guests.adults + guests.children + guests.elderly
            ) +
              calculatePriceForParty(
                tourDetails?.experienceType || "Shared",
                tourDetails?.baseSharedPrice,
                tourDetails?.basePrivatePrice,
                tourDetails?.extraPersonPrice,
                partyType,
                guests.adults + guests.children + guests.elderly
              ) /
                10
          ),
          party: attributes.party,
          activityType:
            attributes?.tripDetails?.[
              Object.keys(attributes.tripDetails || {})[0]
            ]?.tours[0]?.activityType,
          location:
            attributes?.tripDetails?.[
              Object.keys(attributes.tripDetails || {})[0]
            ]?.tours[0]?.meetUpLocation,
          name: attributes?.tripDetails?.[
            Object.keys(attributes.tripDetails || {})[0]
          ].tours[0].experienceName,
          type: attributes?.tripDetails?.[
            Object.keys(attributes.tripDetails || {})[0]
          ].tours[0].experienceType,
          startTime:
            attributes?.tripDetails?.[
              Object.keys(attributes.tripDetails || {})[0]
            ].tours[0].tourTiming.startTime,
          endTime:
            attributes?.tripDetails?.[
              Object.keys(attributes.tripDetails || {})[0]
            ].tours[0].tourTiming.endTime,
          timeZone: initialUsersTourData?.timeZone,
        };

        let res = addUsersTourDataToUrl(`/checkout/success`, data);

        navigate(res);
        window.scrollTo(0, 0);
      } else {
        alert("Failed to complete booking. Please try again.");
      }
    } catch (error) {
      console.error("Error during checkout:", error);
      setShowContactSupportSection(true);
    } finally {
      setLoadingCheckout(false);
    }
  };

  const dataToAdd = {
    experienceId: tourDetails?.id,
    partyType: partyType,
    partySize: guests?.adults + guests?.children + guests?.elderly,
    experienceName: tourDetails?.experienceName,
    selectedTime: selectedDateTime,
    searchedLocationLabel: initialUsersTourData?.searchedLocationLabel,
    guests: guests,
    startDate: initialUsersTourData?.startDate,
    endDate: initialUsersTourData?.endDate,
    latLongDestination: initialUsersTourData?.latLongDestination,
    timeZone: initialUsersTourData?.timeZone,
  };

  const breadcrumbs = [
    { label: "Home", path: addUsersTourDataToUrl("/", dataToAdd) },
    {
      label: tourDetails?.experienceName,
      path: addUsersTourDataToUrl(`/experience/${tourDetails?.id}`, dataToAdd),
    },
    { label: "Checkout" },
  ];

  const handleGuestChange = (type, operation) => {
    setGuests((prevState) => ({
      ...prevState,
      [type]: Math.max(
        prevState[type] + (operation === "increment" ? 1 : -1),
        0
      ),
    }));
  };

  const handleTabChange = (key) => {
    if (key === "shared") {
      setPartyType("Shared");
    } else {
      setPartyType("Private");
    }
  };

  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  useEffect(() => {
    if (email && confirmEmail && email !== confirmEmail) {
      return;
    }

    if (email && confirmEmail && email === confirmEmail) {
      doesAccountExists();
    }
  }, [confirmEmail, email]);

  const doesAccountExists = async () => {
    // Validate email format
    if (!email || !confirmEmail || email !== confirmEmail) {
      return;
    }

    if (!validateEmail(email)) {
      console.error("Invalid email format");
      setAccountExistenceStatusMessage("Please provide a valid email address");
      return;
    }

    // Perform API request and handle response
    try {
      const data = await Api.getAccountExists(email);
      console.log("Response from doesAccountExists:", data?.exists);

      const message = data?.exists
        ? "Provided email paired with existing Wegether account. Booking will be associated with existing account."
        : "Wegether will register a new account with provided email. Booking will be associated with new account.";

      setAccountExistenceStatusMessage(message);
    } catch (error) {
      console.error("Error during API request:", error);
      setAccountExistenceStatusMessage(
        "An error occurred while checking the account. Please try again."
      );
    }
  };

  return (
    <Elements stripe={stripePromise}>
      <div
        style={{
          backgroundColor: "#f0f2f5",
          minHeight: "100vh",
        }}
      >
        <Navbar
          headerDownloadButtonOnClick={() => setDownloadAppModalVisible(true)}
          breadcrumbs={breadcrumbs}
        />
        <div className="main-container">
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "1rem",
              marginTop: "5rem",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            {showContactSupportSection && (
              <div
                style={{
                  backgroundColor: "white",
                  borderColor: "red",
                  borderWidth: "2px",
                  borderStyle: "solid",
                  borderRadius: "0.5rem",
                  marginBottom: "1rem",
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  fontWeight: "500",
                  color: "black",
                  width: "100%",
                }}
              >
                <i
                  style={{
                    padding: "1rem",
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <IoIosInformationCircle
                    style={{
                      fontSize: "1.8rem",
                      paddingTop: "0.1rem",
                      color: "red",
                    }}
                  />
                  An unexpected error occurred you can contact our support at
                  contact@wegethertravel.com
                </i>
              </div>
            )}
            <div
              style={{
                flex: 2,
              }}
            >
              <StyledCard
                className="card-container"
                gradient={"linear-gradient(71deg, white, white, white)"}
              >
                <Flex gap="middle" align="center" justify="center" horizontal>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <RiUserLocationLine
                      style={{
                        color: "rgb(250, 87, 5)",
                        fontSize: "30px",
                        paddingRight: "0.5rem",
                        paddingLeft: "0.5rem",
                        paddingTop: "3px",
                      }}
                    />
                    <Title style={{ margin: 0 }} level={titleLevel.main}>
                      Booking Details
                    </Title>
                  </div>

                  {bookingSectionIconStatus ? (
                    <CheckCircleOutlined
                      style={{
                        marginRight: "30px",
                        color: "green",
                        fontSize: "28px",
                        paddingTop: "3px",
                      }}
                    />
                  ) : (
                    <CloseCircleOutlined
                      style={{
                        marginRight: "30px",
                        color: "rgb(250, 87, 5)",
                        fontSize: "28px",
                        paddingTop: "3px",
                      }}
                    />
                  )}
                </Flex>

                <Flex
                  gap="middle"
                  align="start"
                  style={{ marginTop: "20px" }}
                  justify="space-between"
                  vertical
                >
                  {/* Each label and value/input in its own Flex container with space-between */}
                  <Flex
                    justify="space-between"
                    className="width-100"
                    align="center"
                  >
                    <Title
                      level={titleLevel.sub}
                      style={{
                        margin: 0,
                        textAlign: "start",
                        minWidth: "100px",
                      }}
                    >
                      First Name
                      <Popover
                        content={
                          <div>
                            <Text
                              level={5}
                              style={{ fontWeight: "500", color: "#505050" }}
                            >
                              Your first name is required for the guide to
                              identify your booking.
                            </Text>
                          </div>
                        }
                        title="First Name Requirement"
                      >
                        {/* Popover icon */}
                        <QuestionCircleFilled
                          style={{ color: "#FA5705", marginLeft: 8 }}
                        />
                      </Popover>
                    </Title>
                    <Input
                      defaultValue={email}
                      onChange={(e) => {
                        setFirstName(e.target.value);
                      }}
                      onPaste={(e) => e.preventDefault()}
                      style={{
                        fontSize: "16px",
                        padding: "6px",
                        maxWidth: "500px",
                        width: "100%",
                      }}
                    />
                  </Flex>
                  <Flex
                    justify="space-between"
                    className="width-100"
                    align="center"
                  >
                    <Title
                      level={titleLevel.sub}
                      style={{
                        margin: 0,
                        textAlign: "start",
                        minWidth: "100px",
                      }}
                    >
                      Email
                    </Title>
                    <Input
                      defaultValue={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      onPaste={(e) => e.preventDefault()}
                      style={{
                        fontSize: "16px",
                        padding: "6px",
                        maxWidth: "500px",
                        width: "100%",
                      }}
                    />
                  </Flex>

                  <Flex
                    justify="space-between"
                    className="width-100"
                    align="center"
                  >
                    <Title
                      level={titleLevel.sub}
                      style={{
                        margin: 0,
                        textAlign: "start",
                        minWidth: "100px",
                      }}
                    >
                      Confirm Email
                    </Title>
                    <Input
                      defaultValue={confirmEmail}
                      onChange={(e) => {
                        setConfirmEmail(e.target.value);
                      }}
                      onPaste={(e) => e.preventDefault()}
                      style={{
                        fontSize: "16px",
                        padding: "6px",
                        maxWidth: "500px",
                        width: "100%",
                      }}
                    />
                  </Flex>

                  {accountExistenceStatusMessage && (
                    <AccountStatusCard
                      message={accountExistenceStatusMessage}
                    />
                  )}

                  <BookingDetailsMenuItem
                    titleLevel={titleLevel}
                    label="Experience Name"
                    value={tourDetails?.experienceName}
                  />
                  <BookingDetailsMenuItem
                    titleLevel={titleLevel}
                    label="Experience Type "
                    value={tourDetails?.experienceType}
                    icon={
                      <PartyIcon
                        partyType={tourDetails?.experienceType || ""}
                      />
                    }
                  />
                  <BookingDetailsMenuItem
                    titleLevel={titleLevel}
                    label="Timezone"
                    value={initialUsersTourData?.timeZone}
                    icon={<FaGlobe />}
                  />
                  <BookingDetailsMenuItem
                    titleLevel={titleLevel}
                    label="Date"
                    value={selectedDateTime?.date}
                    editable={true}
                    onClick={showCalendar}
                    icon={<FaRegCalendar />}
                  />
                  <BookingDetailsMenuItem
                    titleLevel={titleLevel}
                    label="Meetup Time"
                    value={selectedDateTime?.startTime}
                    icon={<FaRegClock />}
                  />
                  <BookingDetailsMenuItem
                    titleLevel={titleLevel}
                    label="Wrapup Time"
                    value={initialUsersTourData?.selectedTime.endTime}
                    icon={<FaRegClock />}
                  />
                  <BookingDetailsMenuItem
                    titleLevel={titleLevel}
                    label="Price"
                    value={`${formatCurrency(
                      calculatePriceForParty(
                        tourDetails?.experienceType || "Shared",
                        tourDetails?.baseSharedPrice,
                        tourDetails?.basePrivatePrice,
                        tourDetails?.extraPersonPrice,
                        partyType,
                        guests.adults + guests.children + guests.elderly
                      )
                    )} (USD)`}
                  />
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <BookingDetailsMenuItem
                      titleLevel={titleLevel}
                      label="Party Type"
                      value={`${
                        guests.adults + guests.children + guests.elderly
                      } ${partyType}`}
                      editable={true}
                      onClick={() => setGuestModalVisible(true)}
                      icon={<PartyIcon partyType={partyType} />}
                    />
                    {!validPartyTypeForExperience(
                      partyType,
                      tourDetails?.experienceType || "Shared and Private"
                    )?.valid && (
                      <div
                        style={{
                          color: "red",
                          fontWeight: "500",
                        }}
                      >
                        {validPartyTypeForExperience(
                          partyType,
                          tourDetails?.experienceType || "Shared and Private"
                        )?.errors?.map((error, index) => (
                          <p key={index}>{error}</p>
                        ))}
                      </div>
                    )}
                  </div>
                </Flex>
              </StyledCard>
            </div>

            <div
              style={{
                flex: 1,
                // minWidth: "320px",
                // width: isMobile ? "100%" : "auto"
              }}
            >
              <StyledCard
                className="card-container"
                gradient={"linear-gradient(71deg, white, white, white)"}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "2rem",
                  }}
                >
                  <RiReceiptFill
                    style={{
                      color: "rgb(250, 87, 5)",
                      fontSize: "30px",
                      paddingRight: "0.5rem",
                      paddingLeft: "0.5rem",
                      paddingTop: "3px",
                    }}
                  />

                  <Title
                    level={titleLevel.main}
                    style={{ margin: 0 }}
                    className="summary-title"
                  >
                    Checkout Summary
                  </Title>
                </div>

                <Row justify="space-between">
                  <Col>
                    <Title level={titleLevel.sub} style={{ margin: 0 }}>
                      Subtotal
                    </Title>
                    <Title level={titleLevel.sub} style={{ margin: 0 }}>
                      Booking Fee (10%)
                    </Title>
                    <Title level={titleLevel.sub} style={{ margin: 0 }}>
                      Trip Total
                    </Title>
                  </Col>
                  <Col>
                    <Title
                      level={titleLevel.sub}
                      style={{
                        margin: 0,
                        fontWeight: "500",
                        color: "#606060",
                        textAlign: "end",
                      }}
                    >
                      {formatCurrency(
                        calculatePriceForParty(
                          tourDetails?.experienceType || "Shared",
                          tourDetails?.baseSharedPrice,
                          tourDetails?.basePrivatePrice,
                          tourDetails?.extraPersonPrice,
                          partyType,
                          guests.adults + guests.children + guests.elderly
                        )
                      )}{" "}
                      (USD)
                    </Title>
                    <Title
                      level={titleLevel.sub}
                      style={{
                        margin: 0,
                        fontWeight: "500",
                        color: "#606060",
                        textAlign: "end",
                      }}
                    >
                      {formatCurrency(
                        calculatePriceForParty(
                          tourDetails?.experienceType || "Shared",
                          tourDetails?.baseSharedPrice,
                          tourDetails?.basePrivatePrice,
                          tourDetails?.extraPersonPrice,
                          partyType,
                          guests.adults + guests.children + guests.elderly
                        ) / 10
                      )}{" "}
                      (USD)
                    </Title>
                    <Title
                      level={titleLevel.sub}
                      style={{
                        margin: 0,
                        fontWeight: "500",
                        color: "#606060",
                        textAlign: "end",
                      }}
                    >
                      {formatCurrency(
                        calculatePriceForParty(
                          tourDetails?.experienceType || "Shared",
                          tourDetails?.baseSharedPrice,
                          tourDetails?.basePrivatePrice,
                          tourDetails?.extraPersonPrice,
                          partyType,
                          guests.adults + guests.children + guests.elderly
                        ) +
                          calculatePriceForParty(
                            tourDetails?.experienceType || "Shared",
                            tourDetails?.baseSharedPrice,
                            tourDetails?.basePrivatePrice,
                            tourDetails?.extraPersonPrice,
                            partyType,
                            guests.adults + guests.children + guests.elderly
                          ) /
                            10
                      )}{" "}
                      (USD)
                    </Title>
                  </Col>
                </Row>
                <Divider className="custom-divider" />
                <Row justify="space-between">
                  <Col>
                    <Title level={titleLevel.sub} style={{ margin: 0 }}>
                      Total Payment
                    </Title>
                  </Col>
                  <Col>
                    <Title
                      level={titleLevel.sub}
                      style={{
                        margin: 0,
                        fontWeight: "500",
                        color: "#606060",
                        textAlign: "end",
                      }}
                    >
                      {formatCurrency(
                        calculatePriceForParty(
                          tourDetails?.experienceType || "Shared",
                          tourDetails?.baseSharedPrice,
                          tourDetails?.basePrivatePrice,
                          tourDetails?.extraPersonPrice,
                          partyType,
                          guests.adults + guests.children + guests.elderly
                        ) +
                          calculatePriceForParty(
                            tourDetails?.experienceType || "Shared",
                            tourDetails?.baseSharedPrice,
                            tourDetails?.basePrivatePrice,
                            tourDetails?.extraPersonPrice,
                            partyType,
                            guests.adults + guests.children + guests.elderly
                          ) /
                            10
                      )}{" "}
                      (USD)
                    </Title>
                  </Col>
                </Row>
              </StyledCard>

              {!isMobile && (
                <CheckoutButton
                  revisitedHandleCheckoutButtonPress={
                    revisitedHandleCheckoutButtonPress
                  }
                  setIsAgreementAccepted={setIsAgreementAccepted}
                  isAgreementAccepted={isAgreementAccepted}
                  bookingSectionIconStatus={bookingSectionIconStatus}
                  paymentSectionIconStatus={paymentSectionIconStatus}
                  loadingCheckout={loadingCheckout}
                />
              )}
            </div>
            {!isMobile && (
              <div
                style={{
                  width: "100%",
                }}
              ></div>
            )}

            <div
              style={{
                flex: 2,
              }}
            >
              <StyledCard
                gradient={"linear-gradient(71deg, white, white, white)"}
                className="card-container"
                // style={{ padding: "20px" }}
              >
                <Flex gap="middle" align="center" justify="center" horizontal>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: "2rem",
                    }}
                  >
                    <FaRegCreditCard
                      style={{
                        color: "rgb(250, 87, 5)",
                        fontSize: "30px",
                        paddingRight: "0.5rem",
                        paddingLeft: "0.5rem",
                        paddingTop: "4px",
                      }}
                    />
                    <Title style={{ margin: 0 }} level={titleLevel.main}>
                      Payment Method
                    </Title>
                    {/* <CheckCircleOutlined
                      style={{
                        marginLeft: "15px",
                        color: "green",
                        fontSize: "25px",
                      }}
                    /> */}
                    {paymentSectionIconStatus ? (
                      <CheckCircleOutlined
                        style={{
                          marginLeft: "15px",
                          color: "green",
                          fontSize: "28px",
                          paddingTop: "3px",
                        }}
                      />
                    ) : (
                      <CloseCircleOutlined
                        style={{
                          // marginRight: "30px",
                          color: "rgb(250, 87, 5)",
                          fontSize: "25px",
                          marginLeft: "15px",
                          fontSize: "28px",
                          paddingTop: "3px",
                        }}
                      />
                    )}
                  </div>
                </Flex>

                <StripeTrust />

                <Row justify="center" style={{ position: "relative" }}>
                  <div style={{ width: "100%" }}>
                    <PaymentSection
                      titleLevel={titleLevel}
                      setPaymentSectionIconStatus={setPaymentSectionIconStatus}
                    />
                  </div>
                </Row>
              </StyledCard>
            </div>

            {isMobile ? (
              <div
                style={{
                  // flex:2,
                  width: "100%",
                }}
              >
                <CheckoutButton
                  revisitedHandleCheckoutButtonPress={
                    revisitedHandleCheckoutButtonPress
                  }
                  setIsAgreementAccepted={setIsAgreementAccepted}
                  isAgreementAccepted={isAgreementAccepted}
                  bookingSectionIconStatus={bookingSectionIconStatus}
                  paymentSectionIconStatus={paymentSectionIconStatus}
                  loadingCheckout={loadingCheckout}
                />
              </div>
            ) : (
              <div
                style={{
                  flex: 1,
                  // minWidth: "320px",
                }}
              ></div>
            )}
          </div>

          <Modal
            title={
              <Title style={{ margin: 0 }} level={titleLevel.sub}>
                Select Date
              </Title>
            }
            open={isCalendarVisible}
            onCancel={() => setIsCalendarVisible(false)}
            footer={null}
          >
            <AvailabilityDatesCalender
              availableTimes={tourDetails?.availableTimes}
              handleDateTimeSelect={handleDateTimeSelect}
              lat={tourDetails?.location?.lat}
              long={tourDetails?.location?.long}
            />
          </Modal>

          <Modal
            title="Edit Participants"
            open={isParticipantModalVisible}
            onOk={() => setIsParticipantModalVisible(false)}
            onCancel={() => setIsParticipantModalVisible(false)}
            okText="OK"
            footer={[
              <Button
                key="ok"
                type="primary"
                onClick={() => setIsParticipantModalVisible(false)}
              >
                OK
              </Button>,
            ]}
          >
            {/* Input fields for each participant category */}
            <Row gutter={[16, 16]}>
              <Col span={8}>
                <h4>Adult</h4>
                <InputNumber
                  min={0}
                  value={guests.adults}
                  onChange={(value) => handleParticipantChange("adults", value)}
                  style={{ width: "100%" }}
                />
              </Col>
              <Col span={8}>
                <h4>Child</h4>
                <InputNumber
                  min={0}
                  value={guests.children}
                  onChange={(value) =>
                    handleParticipantChange("children", value)
                  }
                  style={{ width: "100%" }}
                />
              </Col>
              <Col span={8}>
                <h4>Elderly</h4>
                <InputNumber
                  min={0}
                  value={guests.elderly}
                  onChange={(value) =>
                    handleParticipantChange("elderly", value)
                  }
                  style={{ width: "100%" }}
                />
              </Col>
            </Row>

            <div style={{ marginTop: "16px", fontWeight: "bold" }}>
              Total Participants: {totalParticipants} /{" "}
              {tourDetails?.maxParticipants}
            </div>
          </Modal>

          <Modal
            title={"Edit your party type"}
            open={isUserPartyTypeModalVisible}
            onOk={() => setIsUserPartyTypeModalVisible(false)}
            onCancel={() => setIsUserPartyTypeModalVisible(false)}
            okText="OK"
            footer={[
              <Button
                key="ok"
                type="primary"
                onClick={() => setIsUserPartyTypeModalVisible(false)}
              >
                OK
              </Button>,
            ]}
          >
            <Radio.Group
              value={partyType}
              onChange={(e) => setPartyType(e.target.value)}
            >
              <Space direction="vertical">
                <Radio value="Shared">Shared</Radio>
                <Radio value="Private">Private</Radio>
              </Space>
            </Radio.Group>
            {!validPartyTypeForExperience(
              partyType,
              tourDetails?.experienceType || "Shared and Private"
            )?.valid && (
              <div
                style={{
                  color: "red",
                }}
              >
                {validPartyTypeForExperience(
                  partyType,
                  tourDetails?.experienceType || "Shared and Private"
                )?.errors?.map((error, index) => (
                  <p key={index}>{error}</p>
                ))}
              </div>
            )}
          </Modal>

          <DownloadWegetherModal
            downloadAppModalVisible={downloadAppModalVisible}
            setDownloadAppModalVisible={setDownloadAppModalVisible}
          />

          <ParticipantsControlModal
            guestModalVisible={guestModalVisible}
            setGuestModalVisible={setGuestModalVisible}
            handleGuestModalOk={() => {
              setGuestModalVisible(false);
            }}
            handleGuestChange={handleGuestChange}
            guests={guests}
            isShared={partyType === "Shared"}
            handleTabChange={handleTabChange}
            maxParticipants={tourDetails?.maxParticipants || 10}
            experienceType={tourDetails?.experienceType || "Shared and Private"}
          />
        </div>
      </div>
    </Elements>
  );
}

const CheckoutButton = ({
  revisitedHandleCheckoutButtonPress,
  setIsAgreementAccepted,
  isAgreementAccepted,
  bookingSectionIconStatus,
  paymentSectionIconStatus,
  loadingCheckout,
}) => {
  const [checkoutButtonDisabled, setCheckoutButtonDisabled] = useState(true);
  const [checkoutButtonHovered, setCheckoutButtonHovered] = useState(false);

  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    if (
      isAgreementAccepted &&
      bookingSectionIconStatus &&
      paymentSectionIconStatus
    ) {
      setCheckoutButtonDisabled(false);
    } else {
      setCheckoutButtonDisabled(true);
    }
  }, [isAgreementAccepted, bookingSectionIconStatus, paymentSectionIconStatus]);

  return (
    <Flex align="end" justify="center" style={{ flexDirection: "column" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "2rem",
        }}
      >
        <CustomCheckbox
          checked={isAgreementAccepted}
          onChange={setIsAgreementAccepted}
        />
        <div style={{ fontSize: "16px", fontWeight: "500" }}>
          {
            "You and if applicable, on behalf of your participating party, agree to the "
          }
          <a
            href="https://wegethertravel.com/wegether-terms-of-use-en"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "rgb(250, 87, 5)" }}
          >
            Wegether Terms of Use
          </a>
          {" and the "}
          <a
            href="https://wegethertravel.com/wegether-release-of-liability-en"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "rgb(250, 87, 5)" }}
          >
            Wegether Release of Liability
          </a>
          {" by purchasing this experience."}
          <br />
        </div>
      </div>
      <div>
        <span
          style={{
            color: "red",
            fontSize: "16px",
            fontWeight: "500",
            paddingRight: "10px",
          }}
        >
          *<i style={{ color: "black" }}> Required</i>
        </span>
      </div>

      {/* <button
        // disabled={!bookingSectionIconStatus}
        // onClick={submitForm}
        style={{
          backgroundColor: checkoutButtonDisabled
            ? "lightgray"
            : `rgb(250, 87, 5)`,
          padding: "18px 40px",
          borderRadius: "40px",
          color: "white",
          border: "none",
          fontWeight: "bold",
          cursor: "pointer",
          fontSize: "22px",
          marginTop: "2rem",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        }}
        onClick={(e) => revisitedHandleCheckoutButtonPress(e, stripe, elements)}
        disabled={checkoutButtonDisabled}
      >
        Checkout
      </button> */}

      <Button
        shape={"round"}
        size={"large"}
        style={{
          backgroundColor: checkoutButtonDisabled
            ? "lightgray"
            : `rgb(250, 87, 5)`,
          padding: "18px",
          height: "auto",
          padding: "18px 40px",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          marginTop: "2rem",
        }}
        disabled={checkoutButtonDisabled}
        onClick={(e) => revisitedHandleCheckoutButtonPress(e, stripe, elements)}
        loading={loadingCheckout}
      >
        <div
          style={{
            fontSize: "22px",
            fontWeight: "bold",
            color: "white",
          }}
        >
          Checkout
        </div>
      </Button>
    </Flex>
  );
};

export default Checkout;
